import { __module as a } from "./chunk660.js";
import { __require as c } from "./chunk447.js";
import { __require as x } from "./chunk455.js";
var d = a.exports, f;
function m() {
  return f ? a.exports : (f = 1, function(s, h) {
    (function(i, r, o) {
      s.exports = r(c(), x());
    })(d, function(i) {
      return function() {
        var r = i, o = r.lib, _ = o.WordArray, t = r.algo, e = t.SHA256, n = t.SHA224 = e.extend({
          _doReset: function() {
            this._hash = new _.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var u = e._doFinalize.call(this);
            return u.sigBytes -= 4, u;
          }
        });
        r.SHA224 = e._createHelper(n), r.HmacSHA224 = e._createHmacHelper(n);
      }(), i.SHA224;
    });
  }(a), a.exports);
}
export {
  m as __require
};
